<section class="membership-options-page position-relative py-4 py-lg-5">
  <div class="container position-relative z-1">

    <ngb-alert *ngIf="alert" [type]="alert.type" (closed)="closeAlert()" class="sticky-top" style="top: 10px;">
      {{ alert.message }}
    </ngb-alert>

    <div class="text-center mb-4 mb-lg-5">
      <h1 class="page-title display-5 fw-bold mb-3">Select plan</h1>
      <app-progress-stepper
        *ngIf="showProgressStepper"
        [currentStep]="RegistrationFlowStep.MembershipOptions"
        [label]="'Select your protection plan'">
      </app-progress-stepper>
    </div>

    <div
      class="card border-0 rounded-4 text-center px-2 py-4 mb-4 mb-lg-5"
      *ngIf="showBasicAccountButton && showVetGroupMessage && !userAlreadyHasASubscription"
    >
      <span class="membership-selection-title">{{ membershipSelectionSubTitle }}
        <a
          [routerLink]="[]"
          queryParamsHandling="preserve"
          (click)="completeMembershipSelection()"
          class="membership-selection-title"
        >
          <u>{{ membershipSelectionSubTitleButtonText }}</u>
        </a>
      </span>
    </div>

    <p class="text-center mb-4" *ngIf="!showBasicAccountButton">
      To complete your registration, choose the plan that best suits your needs. All plans include microchip registration, access to our 24/7 lost pet helpline and features to reunite you with your lost pet faster.
    </p>

    <div class="row row-cols-1 row-cols-lg-3 g-4 justify-content-center">
      <app-plan-card
        class="col order-3 order-lg-1"
        variant="base"
        [title]="page.basePlan.title"
        [subtitle]="basePlanSubtitle"
        [price]="plan1YearlyPrice"
        [features]="page.basePlan.features"
        ctaText="Choose {{ page.basePlan.title }}"
        secondaryCtaText="Learn more"
        [disabled]="!identibasePlusAvailable || loading"
        [loading]="loading"
        (selectPlan)="selectBase()"
        (secondaryAction)="navigateToProductPage(plan1Route)"
      ></app-plan-card>

      <app-plan-card
        class="col order-2"
        variant="alert"
        [elevated]="true"
        [title]="page.alertPlan.title"
        [subtitle]="alertPlanSubtitle"
        [price]="plan2YearlyPrice"
        [monthlyPrice]="plan2MonthlyPrice"
        [inheritedLabel]="'Everything in ' + page.basePlan.title"
        [features]="page.alertPlan.features"
        ctaText="Choose {{ page.alertPlan.title }}"
        secondaryCtaText="Learn more"
        [disabled]="!identiAlertAvailable || loading"
        [loading]="loading"
        (selectPlan)="selectAlert()"
        (secondaryAction)="navigateToProductPage(plan2Route)"
      ></app-plan-card>

      <app-plan-card
        *ngIf="isIdentiSmartTagPlanAvailable"
        class="col order-1 order-lg-3"
        variant="locator"
        [title]="page.locatorPlan.title"
        [subtitle]="locatorPlanSubtitle"
        [price]="plan3YearlyPrice"
        [originalPrice]="plan3YearlyPriceOriginal"
        [badgeText]="page.locatorPlan.badgeText"
        [iconSrc]="page.locatorPlan.iconSrc"
        [colorOptions]="page.locatorPlan.colorOptions ? page.locatorPlan.colorOptions : []"
        [inheritedLabel]="'Everything in ' + page.alertPlan.title"
        [features]="page.locatorPlan.features"
        ctaText="Choose {{ page.locatorPlan.title }}"
        secondaryCtaText="Learn more"
        [disabled]="!smartTagSubAvailable || loading"
        [loading]="loading"
        (selectPlan)="selectLocator()"
        (secondaryAction)="navigateToProductPage(plan3Route)"
      ></app-plan-card>
    </div>

    <p class="text-center mt-4" *ngIf="!showBasicAccountButton">
      Your subscription includes registration of your pet onto our DEFRA compliant (government approved) database, access to our 24/7 customer helpline and an official microchip registration certificate.
    </p>

    <div class="card mt-4 rounded-4 p-4" *ngIf="showSmartTagPicker" #smartTagPicker>
      <app-smart-tag-configurator
        [petName]="petName || 'your pet'"
        [freeTags]="tagPricing?.freeTags ?? null"
        [tagUnitPrice]="tagUnitPrice"
        subtitle=""
        [showQuantitySelector]="false"
        [showSingleItemBadge]="false"
        skipCtaText="Skip - I’ll choose my tag style later"
        (continueFree)="checkoutLocatorWithFreeTags($event)"
        (continueWithPayment)="checkoutLocatorWithPaidTags($event)"
        (skipTags)="checkoutLocatorOnly()"
      ></app-smart-tag-configurator>
    </div>

    <div class="d-flex flex-column align-items-center mt-4 mt-lg-5" *ngIf="showBasicAccountButton && !showVetGroupMessage">
      <span *ngIf="!userAlreadyHasASubscription">
        Continue with a
        <a
          [routerLink]="[]"
          queryParamsHandling="preserve"
          (click)="completeMembershipSelection()"
          class="complete-link"
        >basic registration</a>
      </span>

      <span *ngIf="userAlreadyHasASubscription">Or continue with your current</span>
      <a
        [routerLink]="[]"
        queryParamsHandling="preserve"
        (click)="continueWithCurrentMembership()"
        class="complete-link"
        *ngIf="userAlreadyHasASubscription"
      >
        {{ currentMembershipName }} membership
      </a>
    </div>

  </div>

  <!-- Decorative layer. It carries the clipping, so the page itself stays scroll-friendly. -->
  <div class="position-absolute top-0 start-0 w-100 h-100 overflow-hidden">
    <app-background-icon
      src="/assets/images/icons/treats-pink.svg"
      [top]="20"
      [left]="15"
      [width]="175"
      [opacity]="0.5"
    />

    <app-background-icon
      src="/assets/images/icons/carry_crate-pink.svg"
      [top]="20"
      [left]="60"
      [width]="230"
      [opacity]="0.5"
    />

    <app-background-icon
      src="/assets/images/icons/cat-pink.svg"
      [top]="20"
      [left]="90"
      [width]="300"
      [opacity]="0.5"
    />

    <app-background-icon
      src="/assets/images/icons/kennel-pink.svg"
      [top]="60"
      [left]="5"
      [width]="140"
      [opacity]="0.5"
    />

    <app-background-icon
      src="/assets/images/icons/medicine-pink.svg"
      [top]="95"
      [left]="20"
      [width]="210"
      [opacity]="0.5"
    />

    <app-background-icon
      src="/assets/images/icons/paw-pink.svg"
      [top]="80"
      [left]="95"
      [width]="130"
      [opacity]="0.5"
    />
  </div>

</section>
